import './styles.scss'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'

import settingsActions from 'redux/settings/actions'
import { getStaticImage } from 'utils/statics'

const ConversationViewPlugin = () => {
  const dispatch = useDispatch()
  const { msgFilterEvent } = useSelector(store => store.settings)

  return (
    <div className='conversation-view-plugin'>
      <div className='conversation-view-plugin__label'>
        <figure>
          <img
            src={getStaticImage('/icons/orange-brand/icon-view-dark.svg')}
            alt={I18n.t('dashboard_conversation-view')}
          />
        </figure>
        <strong>{I18n.t('dashboard_conversation-view')}</strong>
      </div>
      <div className='conversation-view-plugin__filters'>
        <button
          className='conversation-view-plugin__filter'
          title={I18n.t('dashboard_only-activities')}
          onClick={() => dispatch(settingsActions.set({ msgFilterEvent: 'activities' }))}
        >
          <figure>
            <img
              src={msgFilterEvent === 'activities'
                ? getStaticImage('/icons/orange-brand/icon-activities-primary.svg')
                : getStaticImage('/icons/orange-brand/icon-activities-dark.svg')
              }
              alt={I18n.t('dashboard_only-activities')}
            />
          </figure>
        </button>
        <button
          className='conversation-view-plugin__filter'
          title={I18n.t('dashboard_only-messages')}
          onClick={() => dispatch(settingsActions.set({ msgFilterEvent: 'messages' }))}
        >
          <figure>
            <img
              src={msgFilterEvent === 'messages'
                ? getStaticImage('/icons/orange-brand/icon-messages-primary.svg')
                : getStaticImage('/icons/orange-brand/icon-messages-dark.svg')
              }
              alt={I18n.t('dashboard_only-messages')}
            />
          </figure>
        </button>
        <button
          className='conversation-view-plugin__filter'
          title={I18n.t('dashboard_messages-activities')}
          onClick={() => dispatch(settingsActions.set({ msgFilterEvent: 'all' }))}
        >
          <figure>
            <img
              src={msgFilterEvent === 'all'
                ? getStaticImage('/icons/orange-brand/icon-activities-messages-primary.svg')
                : getStaticImage('/icons/orange-brand/icon-activities-messages-dark.svg')
              }
              alt={I18n.t('dashboard_messages-activities')}
            />
          </figure>
        </button>
      </div>
    </div>
  )
}

export default ConversationViewPlugin
